/* ============
 * Getters for the requirements module
 * ============
 *
 * The getters that are available on the
 * requirements module.
 */

export default {
  requirementsInfo: state => { return state.requirements }
}



// WEBPACK FOOTER //
// ./src/store/modules/requirements/getters.js